import { render, staticRenderFns } from "./BroadcastModal.vue?vue&type=template&id=b72f1d56&scoped=true&"
import script from "./BroadcastModal.vue?vue&type=script&lang=js&"
export * from "./BroadcastModal.vue?vue&type=script&lang=js&"
import style0 from "./BroadcastModal.vue?vue&type=style&index=0&id=b72f1d56&prod&lang=scss&scoped=true&"
import style1 from "./BroadcastModal.vue?vue&type=style&index=1&id=b72f1d56&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72f1d56",
  null
  
)

export default component.exports